import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { injectIntl } from 'react-intl';

// Component
import Link from '../../Link';
import s from './PopularLocationGridItem.css';

const PopularLocationGridItem = ({ location, locationAddress, path }) => {
  return (
    <div>
      <Link className={s.GridColZoom} to={`/s?&address=${locationAddress}&chosen=1`}>
        <div className={cx(s.GridWrap)} style={{ backgroundImage: `url(${path})` }}></div>
        <div className={cx(s.placeWrap)}>{location}</div>
      </Link>
    </div>
  );
};

PopularLocationGridItem.propTypes = {
  location: PropTypes.string,
  locationAddress: PropTypes.string,
  path: PropTypes.string,
};

export default injectIntl(withStyles(s)(PopularLocationGridItem));
